var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYolftLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 39,
    viewBox: "0 0 132 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.843 38V29.268L0.222 12.84H6.845L10.952 21.313L12.025 24.199L13.061 21.313L17.131 12.84H23.458L14.8 29.268V38H8.843ZM36.0288 38.592C28.2218 38.592 23.4118 33.56 23.4118 25.457C23.4118 17.317 28.2218 12.248 36.0288 12.248C43.7988 12.248 48.6088 17.317 48.6088 25.457C48.6088 33.56 43.7988 38.592 36.0288 38.592ZM36.0288 33.745C40.1358 33.745 42.5408 30.637 42.5408 25.457C42.5408 20.277 40.1358 17.095 36.0288 17.095C31.8848 17.095 29.4798 20.24 29.4798 25.457C29.4798 30.637 31.8848 33.745 36.0288 33.745ZM52.3009 38V12.84H58.2209V33.19H69.2839V38H52.3009ZM72.4631 38V12.84H90.5191V17.539H78.3831V23.681H89.0761V28.38H78.3831V38H72.4631ZM100.4 38V17.687H92.5931V12.84H114.164V17.687H106.357V38H100.4Z",
    fill: "#2B2D2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.719 0L130.728 10.4062H116.709L123.719 0Z",
    fill: "#298C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.719 23.125L116.709 12.7188L130.728 12.7188L123.719 23.125Z",
    fill: "#8D1F17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYolftLogo);
export default __webpack_public_path__ + "static/media/yolft-logo.093aa8be214225dede9c6142402465d5.svg";
export { ForwardRef as ReactComponent };